/**
 * The consent store. `docs/reference/legal/compliance.md` holds the terms
 * this serves.
 */

export const CONSENT_KEY = 'klConsent';

/** One entry per tracking category, keyed by its id. */
export interface ConsentRecord {
  [categoryId: string]: boolean;
}

/** Storage throws in Safari private mode, and that visitor has not chosen. */
export const readConsent = (): ConsentRecord | null => {
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as ConsentRecord;
    }
  } catch (e) {
    // Storage is unavailable, or the stored value is not a record.
  }
  return null;
};

export const writeConsent = (record: ConsentRecord): void => {
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
  } catch (e) {
    // Storage is unavailable, so the banner shows again next visit.
  }
};

/** The Global Privacy Control signal, as the compliance file defines it. */
export const hasGPC = (): boolean =>
  (navigator as any).globalPrivacyControl === true;

export const GPC_NOTICE_KEY = 'klConsentGpcNotice';

/** Whether the visitor has already dismissed the GPC notice. */
export const gpcNoticeSeen = (): boolean => {
  try {
    return window.localStorage.getItem(GPC_NOTICE_KEY) === 'true';
  } catch (e) {
    // Storage is unavailable, so the notice shows again.
  }
  return false;
};

export const markGpcNoticeSeen = (): void => {
  try {
    window.localStorage.setItem(GPC_NOTICE_KEY, 'true');
  } catch (e) {
    // Storage is unavailable, so the notice shows again.
  }
};
